import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    walletPayment: 0,
    walletDetails: null,
    withdrwalAmount: 0,
    walletEnable: false
};
export const walletPaymentSlice = createSlice({
    name: "subscription",
    initialState,
    reducers: {
        setWalletPayment: (state, action) => {
            state.walletPayment += 1;
        },

        setWalletDetails: (state, action) => {
            state.walletDetails = action?.payload
        },
        setWithdrawlAmount: (state, action) => {
            state.withdrwalAmount = action.payload
        },
        setWalletEnable: (state, action) => {
            state.walletEnable = action?.payload
        }
    },
});

export const { setWalletPayment, setWalletDetails, setWithdrawlAmount, setWalletEnable } = walletPaymentSlice.actions;
export default walletPaymentSlice.reducer;
